/**
 * Data attribute used to mark interactive elements that should not trigger the message modal sheet.
 * Used by InteractionRequestItem to mark bot interaction forms.
 * Checked in MessageLayout.tsx onClick handler.
 */
export const DATA_ATTR_INTERACTION_REQUEST = 'data-interaction-request'
